import React from 'react';

import { ModalsV2Context } from 'src/providers/ModalsV2Provider';

export const useModalsV2Context = () => {
  return React.use(ModalsV2Context);
};
